import React from "react";
import styles from "./styles.module.css";
import { UserContext } from "../../UserContext";

const Contato = () => {
  const { data, permission, modules } = React.useContext(UserContext);

    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Fale Conosco</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Fale Conosco</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="content-full-width">
                        <div className="column dt-sc-three-fourth first contact_form_outer">
                            <div id="map">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.7424639878977!2d-46.36266302489157!3d-23.541763478813294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce7bf768758167%3A0xc9922c5e32241b01!2sCl%C3%ADnica%20CreSer!5e0!3m2!1spt-BR!2sbr!4v1726935838733!5m2!1spt-BR!2sbr"
                                    title="Endereço clinica Crescer"
                                    width="100%"
                                    height="500"
                                    className={styles.googleMaps}
                                />
                            </div>
                        </div>

                        <div className="column dt-sc-one-fourth class_hours">
                            <h2>Horário de atendimento</h2>
                            <ul className="class_hours">
                                <li>Segunda<span>10am - 19pm</span></li>
                                <li>Terça<span>10am - 19pm</span></li>
                                <li>Quarta<span>10am - 19pm</span></li>
                                <li>Quinta<span>10am - 19pm</span></li>
                                <li>Sexta<span>10am - 19pm</span></li>
                                <li>Sabado<span>8am - 13pm</span></li>
                                <li>Domingo<span>FECHADO</span></li>
                            </ul>
                            <div className="dt-sc-hr-small"></div>
                            <aside className="widget widget_text">
                                <div className="textwidget">
                                    <p className="dt-sc-contact-info"><span className="fa fa-map-marker"></span> R. Benedito Leite, 52 - Vila Correa, Ferraz de Vasconcelos - SP </p>
                                    <p className="dt-sc-contact-info"><span className="fa fa-phone"></span> (11) 91913-9787 </p>
                                    <p className="dt-sc-contact-info"><span className="fa fa-envelope"></span>
                                        <a href="mailto:clinicacrescerferraz@hotmail.com">
                                            <span className="__cf_email__">clinicacrescerferraz@hotmail.com</span>
                                        </a>
                                    </p>
                                </div>
                            </aside>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Contato;
